import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { IEmployee } from '../employee';
import {EmployeeService} from "../services/employee.service";
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { listEmployees } from 'src/app/stores/global/employees/employees.store';

@Injectable({
  providedIn: 'root'
})
export class EmployeesResolver  {
  constructor(
    private store: Store<AppStateInterface>
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IEmployee[]> {
    // JE: Not sure if the resolver is event needed when just calling the dispatcher
    this.store.dispatch(listEmployees({request: {pageNumber: 0, pageSize: 999999, showHidden: true}}));
    return of([]);
  }
}
